import { render, staticRenderFns } from "./CRMOrders.vue?vue&type=template&id=57c6c666&"
import script from "./CRMOrders.vue?vue&type=script&lang=js&"
export * from "./CRMOrders.vue?vue&type=script&lang=js&"
import style0 from "./CRMOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports